module.exports = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-rule="evenodd"><path d="M16.875 18H1.125A1.125 1.125 0 0 1 0 16.875v-2.25c0-.621.504-1.125 1.125-1.125h15.75c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125zM16.875 11.25H1.125A1.125 1.125 0 0 1 0 10.125v-2.25C0 7.254.504 6.75 1.125 6.75h15.75c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125zM16.875 4.5H1.125A1.125 1.125 0 0 1 0 3.375v-2.25C0 .504.504 0 1.125 0h15.75C17.496 0 18 .504 18 1.125v2.25c0 .621-.504 1.125-1.125 1.125z"/></g></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/menu-4.js
// module id = 1271
// module chunks = 14